import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import RSVPPage from "./pages/RSVPPage";
import EventsRSVPPage from "./pages/EventsRSVPPage";
import FlightsPage from "./pages/FlightsPage";
import MealsPage from "./pages/MealsPage";
import TravelPage from "./pages/TravelPage";
import ItineraryPage from "./pages/ItineraryPage";
import AccommodationsPage from "./pages/AccommodationsPage";
import RegistryPage from "./pages/RegistryPage";
import FAQPage from "./pages/FAQPage";
import BridalPartyPage from "./pages/BridalPartyPage";
import SaveTheDatePage from "./pages/SaveTheDatePage";
import SaveTheDateCardPage from "./pages/SaveTheDateCardPage";
import SaveTheDatePrintPage from "./pages/SaveTheDatePrintPage";
import AdminPage from "./pages/AdminPage";
import "./App.css";

function App() {
  return (
    <div className="App grain-overlay">
      <BrowserRouter>
        <Routes>
          {/* Standalone pages - no navigation */}
          <Route path="address" element={<SaveTheDatePage />} />
          <Route path="save-the-date-card" element={<SaveTheDateCardPage />} />
          <Route path="save-the-date-print" element={<SaveTheDatePrintPage />} />
          <Route path="admin" element={<AdminPage />} />
          
          {/* Main wedding website with navigation */}
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="rsvp" element={<RSVPPage />} />
            <Route path="events-rsvp" element={<EventsRSVPPage />} />
            <Route path="bridal-party" element={<BridalPartyPage />} />
            <Route path="flights" element={<FlightsPage />} />
            <Route path="meals" element={<MealsPage />} />
            <Route path="travel" element={<TravelPage />} />
            <Route path="itinerary" element={<ItineraryPage />} />
            <Route path="accommodations" element={<AccommodationsPage />} />
            <Route path="registry" element={<RegistryPage />} />
            <Route path="faq" element={<FAQPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
